import { withSuspense } from '@lib/common/hoc';
import { lazy } from 'react';

const CompanyDedupePage = withSuspense(lazy(() => import('./company-dedupe.page')));
export default CompanyDedupePage;
